import { LightTheme, DarkTheme } from "./theme";
import { createContext, useState, useContext, useCallback } from "react";
import { ThemeProvider as StyledProvider } from "styled-components";

interface ThemeContextType {
    theme: string;
    setTheme: React.Dispatch<React.SetStateAction<string>>;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
    const [theme, setTheme] = useState<string>(window.localStorage.getItem("theme") || "light");
    const themeObject = theme === 'light' ? LightTheme : DarkTheme; // DarkTheme은 나중에 정의
    
    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            <StyledProvider theme={themeObject}>
                {children}
            </StyledProvider>
        </ThemeContext.Provider>
    );
};

// theme toggle을 위한 custom hook
function useTheme() {
    const context = useContext(ThemeContext);

    if (!context) {
        throw new Error("useTheme은 반드시 ThemeProvider 내부에서 사용되어야 합니다.");
    }

    const { theme, setTheme } = context;
    
    const toggle = useCallback(() => {
        setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
        window.localStorage.setItem("theme", theme === 'light' ? 'dark' : 'light'); // 토글 후의 테마 저장
    }, [setTheme]);

    return { theme, toggle };
}

export { ThemeProvider, useTheme };